import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { OfferItemFlightDataAlternative } from '@/interfaces/offer';
import FlightDetails from './FlightDetails.vue';
import { computed } from 'vue';
import { convertDateToTime } from '@/js/utils/dateTimeUtils';

type Props = {
	flightData: OfferItemFlightDataAlternative | undefined;
	duration?: number;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'UnverifiedFlightDetails',
  props: {
    flightData: {},
    duration: {}
  },
  setup(__props: any) {



const numberOfStops = computed(() => {
	if (!__props.flightData?.DirectFlightAssumed && __props.flightData?.NumberOfStops === 0) return;
	return __props.flightData?.NumberOfStops;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FlightDetails, {
    "departure-time": _unref(convertDateToTime)(_ctx.flightData?.Departure.Date),
    "arrival-time": _unref(convertDateToTime)(_ctx.flightData?.Arrival.Date),
    airline: _ctx.flightData?.Departure?.Airline?.Name,
    "number-of-stops": numberOfStops.value,
    duration: _ctx.duration
  }, null, 8 /* PROPS */, ["departure-time", "arrival-time", "airline", "number-of-stops", "duration"]))
}
}

})